export default function synchronousFetch(url) {
  const request = new XMLHttpRequest();
  request.open('GET', url, false);
  request.send();

  if (request.status === 200 && request.responseText) {
    return JSON.parse(request.responseText);
  }

  const error = new Error(request.statusText);
  error.response = {status: request.status};
  throw error;
}



// WEBPACK FOOTER //
// ./src/util/synchronousFetch.js